/**
 * Сопоставление ФИО из списка сотрудников с именем локальной учётки Windows.
 * Частый случай: украинское «Мамроцька» в структуре vs русское «Мамроцкая» / латиница Marina_Mamrockaya в Windows.
 */

export function foldPersonNameForWindowsMatch(s) {
  return String(s || '')
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/ґ/g, 'г')
    .replace(/є/g, 'е')
    .replace(/і/g, 'и')
    .replace(/ї/g, 'и')
    .replace(/[ъь]/g, '')
    .replace(/[_-]+/g, ' ')
    .replace(/ая(?=\s|$)/g, 'а')
    .replace(/яя(?=\s|$)/g, 'я')
    .replace(/\s+/g, ' ')
    .trim();
}

export function windowsAccountNamesMatch(a, b, toCyrillicFio) {
  const left = String(a || '').trim();
  const right = String(b || '').trim();
  if (!left || !right) return false;
  if (left.toLowerCase() === right.toLowerCase()) return true;
  if (foldPersonNameForWindowsMatch(left) === foldPersonNameForWindowsMatch(right)) return true;
  if (typeof toCyrillicFio === 'function') {
    const foldCyr = (name) => foldPersonNameForWindowsMatch(toCyrillicFio(name) || name);
    if (foldCyr(left) && foldCyr(left) === foldCyr(right)) return true;
  }
  return false;
}

export function resolveWindowsAccountName(requestedName, localNames, toCyrillicFio) {
  const requested = String(requestedName || '').trim();
  if (!requested) return null;
  const names = (localNames || []).map((n) => String(n || '').trim()).filter(Boolean);
  const exact = names.find((n) => n.toLowerCase() === requested.toLowerCase());
  if (exact) return exact;
  return names.find((n) => windowsAccountNamesMatch(requested, n, toCyrillicFio)) || null;
}

export function builtEmployeeWindowsName(employee) {
  const first = String(employee?.first_name || '').trim();
  const last = String(employee?.last_name || '').trim();
  if (!last || last === '-') return first;
  return `${first} ${last}`.trim();
}

export function employeeWindowsNameCandidates(employee, messengerUser) {
  const names = [];
  const push = (n) => {
    const t = String(n || '').trim();
    if (t && !names.includes(t)) names.push(t);
  };
  if (messengerUser && messengerUser.windows_username) push(messengerUser.windows_username);
  const built = builtEmployeeWindowsName(employee);
  if (built) {
    push(built);
    const first = String(employee?.first_name || '').trim();
    const last = String(employee?.last_name || '').trim();
    if (first && last && last !== '-') push(`${last} ${first}`);
  }
  if (messengerUser) {
    push(messengerUser.username);
    push(messengerUser.fio);
  }
  return names;
}

export function findLocalWindowsUser(localWindowsUsers, candidates, toCyrillicFio) {
  const users = Array.isArray(localWindowsUsers) ? localWindowsUsers : [];
  const localNames = users.map((u) => (u && (u.Name || u.name)) || '').map((n) => String(n).trim()).filter(Boolean);
  for (const cand of candidates || []) {
    const resolved = resolveWindowsAccountName(cand, localNames, toCyrillicFio);
    if (resolved) {
      return users.find((u) => String((u && (u.Name || u.name)) || '').trim() === resolved) || null;
    }
  }
  return null;
}

export function findLocalWindowsUserForEmployee(employee, localWindowsUsers, messengerUser, toCyrillicFio) {
  return findLocalWindowsUser(
    localWindowsUsers,
    employeeWindowsNameCandidates(employee, messengerUser),
    toCyrillicFio
  );
}
